import { useQuery, useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig, QueryConfig } from '@/lib/react-query';
import { SubscriptionResponse } from '../types';
import { showNotification } from '@/utils/notificationUtils';

type UseSubscriptionsOptions = {
  subscriberId?: string;
  businessId?: string;
};

export const linkSubscriber = ({
  businessId,
  subscriberId,
}: UseSubscriptionsOptions): Promise<UseSubscriptionsOptions> => {
  return axios.post(`/plans/link-subscriber`, { businessId, subscriberId });
};
type UseLinkSubscriptionOptions = {
  config?: MutationConfig<typeof linkSubscriber>;
};

export const useLinkSubscriber = ({ config }: UseLinkSubscriptionOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Subscriber linked successfully',
      });
    },
    ...config,
    mutationFn: linkSubscriber,
  });
};
